const { config } = require('../../config');
const merge = require('deepmerge')


const configFromProject = (project) => {
    // Check if crowdfunding config exists
    const configProject = config.projects.find(c => {
        return c.id[process.env.GATSBY_ACTIVE_ENV] === project.id;
    })

    const data = merge.all([config.defaults, (configProject ? configProject : {}), project]);


    return data;
}

const pageContextFromProject = (project) => {
    return {
        project:configFromProject(project),
    }
}

const metaForHelmets = (meta) => {
    const helmetMeta = [];

    if (meta) {
        if (meta.description) {
            helmetMeta.push({
                name: `description`,
                content: meta.description,
            });
        }
        if (meta.theme_color) {
            helmetMeta.push({
                name: `theme-color`,
                content: meta.theme_color,
            });
        }
        if (meta.og) {
            if (meta.og.type) {
                helmetMeta.push({
                    property: `og:type`,
                    content: meta.og.type,
                });
            }
            if (meta.og.url) {
                helmetMeta.push({
                    property: `og:url`,
                    content: meta.og.url,
                });
            }
            if (meta.og.title) {
                helmetMeta.push({
                    property: `og:title`,
                    content: meta.og.title,
                });
            }
            if (meta.og.description) {
                helmetMeta.push({
                    property: `og:description`,
                    content: meta.og.description,
                });
            }
            if (meta.og.image) {
                helmetMeta.push({
                    property: `og:image`,
                    content: meta.og.image,
                });
            }
        }
        if (meta.twitter) {
            if (meta.twitter.card) {
                helmetMeta.push({
                    property: `twitter:card`,
                    content: meta.twitter.card,
                });
            }
            if (meta.twitter.url) {
                helmetMeta.push({
                    property: `twitter:url`,
                    content: meta.twitter.url,
                });
            }
            if (meta.twitter.title) {
                helmetMeta.push({
                    property: `twitter:title`,
                    content: meta.twitter.title,
                });
            }
            if (meta.twitter.description) {
                helmetMeta.push({
                    property: `twitter:description`,
                    content: meta.twitter.description,
                });
            }
            if (meta.twitter.image) {
                helmetMeta.push({
                    property: `twitter:image`,
                    content: meta.twitter.image,
                });
            }
        }
        if (meta.msapplication) {
            if (meta.msapplication.tileColor) {
                helmetMeta.push({
                    name: `msapplication-TileColor`,
                    content: meta.msapplication.tileColor,
                });
            }
            if (meta.msapplication.tileImage) {
                helmetMeta.push({
                    name: `msapplication-TileImage`,
                    content: meta.msapplication.tileImage,
                });
            }
        }
    }
    return helmetMeta;
}


module.exports = { configFromProject, pageContextFromProject, metaForHelmets }